import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { ServiceGroup } from '../models/service-group.model';
import { environment } from '../../environments/environment';

export interface CreateServiceGroupDto {
  name: string;
  description?: string;
  isActive?: boolean;
  notificationEmails?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ServiceGroupService {
  private apiUrl = `${environment.apiUrl}/ServiceGroup`;

  constructor(private http: HttpClient) { }

  getAllServiceGroups(): Observable<ServiceGroup[]> {
    return this.http.get<ServiceGroup[]>(this.apiUrl).pipe(retry(2));
  }

  addServiceGroup(serviceGroup: ServiceGroup): Observable<ServiceGroup> {
    const createDto: CreateServiceGroupDto = {
      name: serviceGroup.name,
      description: serviceGroup.description,
      isActive: serviceGroup.isActive !== undefined ? serviceGroup.isActive : true,
      notificationEmails: serviceGroup.notificationEmails
    };
    return this.http.post<ServiceGroup>(this.apiUrl, createDto);
  }

  updateServiceGroup(id: string, serviceGroup: ServiceGroup): Observable<ServiceGroup> {
    return this.http.put<ServiceGroup>(`${this.apiUrl}/${id}`, serviceGroup);
  }
}



